import styled from "styled-components";

export const FullScreenModal = styled.div`
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: red;

    overflow: hidden;

    display: flex;
    flex-direction: column;
`;

export const ProductGalleryWrapper = styled.div`
    width: 38%;
    height: 100%;
    margin: 0 auto;
    max-width: 38%;
`;

export const Header = styled.div`
    width: 100%;
    background-color: aliceblue;
`; 

export const Content = styled.div`
    background-color: white;
    flex-grow: 1;

    .swiper-wrapper{
        margin-top: 100px;
        height: 586px;
        background-color: red;

        align-items: center;
        display: flex;
        justify-content: center;
    }
    
    img{
        border-radius: 0 !important;
        margin: 0 !important;
    }
`;

export const FullScreenImage = styled.img`

`;